import React from 'react'
import Layout from '../../common/Layout'
import AdviserAddContainer from '../../features/AdministrationPortal/Whitelisting/AdviserAdd/AdviserAddContainer'
import 'bootstrap/dist/css/bootstrap.min.css';

export default {
  path: '/administration/add-ifa',
  async action () {
    return {
      title: 'Add Adviser',
      component: <Layout containerWell>
        <AdviserAddContainer />
      </Layout>
    }
  }
}
